import React, { useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import {
    Box, Chip, Collapse, Container, Divider, Grid, IconButton, LinearProgress, Paper, Table, TableBody, TableCell, TableContainer,
    TableHead, TableRow, Skeleton, Card, Typography, Avatar, Tooltip, Alert, Snackbar, Dialog, FormControl, Select, MenuItem,
    InputLabel, TextField, Switch, List, ListItem, ListItemText, ListItemIcon, Popover, Button, Stack, CardContent, CardActions,
    useTheme, useMediaQuery
} from "@mui/material";
import {
    Add, Edit, CloudUpload as CloudUploadIcon, Save, KeyboardArrowUp, KeyboardArrowDown, History,
    AssignmentAdd, AssignmentTurnedIn, Description, Refresh as RefreshIcon, PictureAsPdf as PdfIcon,
    Search, ViewColumn as ViewColumnIcon, Visibility as VisibilityIcon, VisibilityOff as VisibilityOffIcon,
    Person as PersonIcon, Phone as PhoneIcon, Email as EmailIcon, Home as HomeIcon, School as SchoolIcon,
    AttachMoney as AttachMoneyIcon, Badge as BadgeIcon,
    LocationCity as LocationCityIcon, Public as PublicIcon, Cake as CakeIcon, GpsFixed as GpsFixedIcon,
    FamilyRestroom as FamilyRestroomIcon, AccountBalance as AccountBalanceIcon, Diversity3 as Diversity3Icon,
    Male as MaleIcon, Female as FemaleIcon, ExpandMore as ExpandMoreIcon, ExpandLess as ExpandLessIcon,
    VerifiedUser,
    Delete
} from "@mui/icons-material";
import ModalView from "../model/ModelView";
import authService from "../Auth/AuthService";
import AssignmentIcon from "@mui/icons-material/Assignment";
import MarksView from "../marksheet/MarksView";
import ClassRoomForm from '../view-form/ClassRoomForm';
import MarksheetForm from '../marksheet/MarksheetForm';
import StudentRegister from '../register/StudentRegister';
import FileUploadPage from '../model/FileUploadPage';
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import { getAcademicYear } from '../utils/academicYear';
import Swal from 'sweetalert2';

const StudentPage = ({ user }) => {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
    const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });

    const [students, setStudents] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    // const { schoolCode } = useParams();
    const hasFetched = useRef(false);

    const [openForm, setOpenForm] = useState(false);
    const [upload, setUpload] = useState(false);
    const [openMark, setOpenMark] = useState(false);
    const [openEntry, setOpenEntry] = useState(false);
    const [openClass, setClass] = useState(false);

    const [marksheet, setMarksheet] = useState([]);
    const [selectedStudent, setSelectedStudent] = useState(null);
    const [openRow, setOpenRow] = useState({});

    const [editingClassRoom, setEditingClassRoom] = useState(null);
    const [classRoom, setClassRoom] = useState({});
    const [markEntry, setMarkEntry] = useState({});
    const [room, setRoom] = useState();
    const [showPdf, setShowPdf] = useState(null);
    const [open, setOpen] = useState(false);

    const DOC_URL = authService.DOC_URL
    const navigate = useNavigate();

    const currentAcademicYear = getAcademicYear(new Date());
    const [filteredStudents, setFilteredStudents] = useState([]);
    const [search, setSearch] = useState({
        searchBy: "academicYear",
        keyword: "",
    });

    // Column customization state
    const [columnVisibility, setColumnVisibility] = useState({
        expand: true,
        id: true,
        image: !isMobile,
        studentCode: false,
        firstName: true,
        lastName: !isMobile,
        fullName: isMobile,
        aadhaarNumber: !isMobile,
        phone: true,
        email: false,
        gender: !isMobile,
        dateOfBirth: !isMobile,
        address: false,
        city: false,
        state: false,
        pincode: false,
        country: false,
        stayType: false,
        anyRelativeIn: false,
        fatherName: !isMobile,
        fatherEducation: false,
        motherName: false,
        motherEducation: false,
        annualIncome: false,
        religion: false,
        category: false,
        caste: false,
        motherTongue: false,
        parmanentAddress: false,
        guardianName: false,
        transport: false,
        isActive: !isMobile,
        action: true,
        classDetails: true,
    });

    const [columnOrder, setColumnOrder] = useState([
        'expand',
        'id',
        'studentCode',
        'image',
        'firstName',
        'lastName',
        'fullName',
        'aadhaarNumber',
        'phone',
        'email',
        'gender',
        'dateOfBirth',
        'address',
        'city',
        'state',
        'pincode',
        'country',
        'stayType',
        'anyRelativeIn',
        'fatherName',
        'fatherEducation',
        'motherName',
        'motherEducation',
        'annualIncome',
        'religion',
        'category',
        'caste',
        'motherTongue',
        'parmanentAddress',
        'guardianName',
        'transport',
        'isActive',
        'action',
        'classDetails'
    ]);

    // Column customization popover state
    const [anchorEl, setAnchorEl] = useState(null);
    const openColumnPopover = Boolean(anchorEl);

    // Card expanded state for mobile
    const [expandedCards, setExpandedCards] = useState({});

    // Column configuration
    const columnConfig = {
        expand: { label: "Expand", icon: <KeyboardArrowDown /> },
        id: { label: "ID", icon: <BadgeIcon /> },
        studentCode: { label: "Student Code", icon: <BadgeIcon /> },
        image: { label: "Photo", icon: <Avatar /> },
        firstName: { label: "First Name", icon: <PersonIcon /> },
        lastName: { label: "Last Name", icon: <PersonIcon /> },
        fullName: { label: "Full Name", icon: <PersonIcon /> },
        aadhaarNumber: { label: "Aadhaar", icon: <BadgeIcon /> },
        phone: { label: "Phone", icon: <PhoneIcon /> },
        email: { label: "Email", icon: <EmailIcon /> },
        gender: { label: "Gender", icon: <PersonIcon /> },
        dateOfBirth: { label: "DOB", icon: <CakeIcon /> },
        address: { label: "Address", icon: <HomeIcon /> },
        city: { label: "City", icon: <LocationCityIcon /> },
        state: { label: "State", icon: <LocationCityIcon /> },
        pincode: { label: "Pincode", icon: <GpsFixedIcon /> },
        country: { label: "Country", icon: <PublicIcon /> },
        stayType: { label: "Stay Type", icon: <HomeIcon /> },
        anyRelativeIn: { label: "Relative In", icon: <FamilyRestroomIcon /> },
        fatherName: { label: "Father", icon: <PersonIcon /> },
        fatherEducation: { label: "Father Edu.", icon: <SchoolIcon /> },
        motherName: { label: "Mother", icon: <PersonIcon /> },
        motherEducation: { label: "Mother Edu.", icon: <SchoolIcon /> },
        annualIncome: { label: "Annual Income", icon: <AttachMoneyIcon /> },
        religion: { label: "Religion", icon: <Diversity3Icon /> },
        category: { label: "Category", icon: <AccountBalanceIcon /> },
        caste: { label: "Caste", icon: <Diversity3Icon /> },
        motherTongue: { label: "Mother Tongue", icon: <PublicIcon /> },
        parmanentAddress: { label: "Permanent Address", icon: <HomeIcon /> },
        guardianName: { label: "Guardian", icon: <PersonIcon /> },
        transport: { label: "Transport", icon: <GpsFixedIcon /> },
        isActive: { label: "Status", icon: <VerifiedUser /> },
        action: { label: "Action", icon: <Edit /> },
        classDetails: { label: "Class Details", icon: <SchoolIcon /> },
    };

    // Load column preferences from localStorage
    const loadColumnPreferences = () => {
        try {
            const savedVisibility = localStorage.getItem('student_columnVisibility');
            const savedOrder = localStorage.getItem('student_columnOrder');

            if (savedVisibility) {
                const parsed = JSON.parse(savedVisibility);
                // Merge with defaults to handle new columns
                setColumnVisibility(prev => ({ ...prev, ...parsed }));
            }
            if (savedOrder) {
                setColumnOrder(JSON.parse(savedOrder));
            }
        } catch (error) {
            console.error('Error loading column preferences:', error);
        }
    };

    // Save column preferences to localStorage
    const saveColumnPreferences = (visibility, order) => {
        try {
            localStorage.setItem('student_columnVisibility', JSON.stringify(visibility));
            localStorage.setItem('student_columnOrder', JSON.stringify(order));
        } catch (error) {
            console.error('Error saving column preferences:', error);
        }
    };

    // Handle column visibility toggle
    const handleColumnToggle = (columnKey) => {
        setColumnVisibility(prev => {
            const newVisibility = {
                ...prev,
                [columnKey]: !prev[columnKey]
            };
            saveColumnPreferences(newVisibility, columnOrder);
            return newVisibility;
        });
    };

    // Reset columns to default
    const handleResetColumns = () => {
        const defaultVisibility = {
            expand: true,
            id: false,
            studentCode: false,
            image: !isMobile,
            firstName: true,
            lastName: !isMobile,
            fullName: isMobile,
            aadhaarNumber: !isMobile,
            phone: true,
            email: false,
            gender: !isMobile,
            dateOfBirth: !isMobile,
            address: false,
            city: false,
            state: false,
            pincode: false,
            country: false,
            stayType: false,
            anyRelativeIn: false,
            fatherName: !isMobile,
            fatherEducation: false,
            motherName: false,
            motherEducation: false,
            annualIncome: false,
            religion: false,
            category: false,
            caste: false,
            motherTongue: false,
            parmanentAddress: false,
            guardianName: false,
            transport: false,
            isActive: !isMobile,
            action: true,
            classDetails: true,
        };
        const defaultOrder = [
            'expand',
            'id',
            'studentCode',
            'image',
            'firstName',
            'lastName',
            'fullName',
            'aadhaarNumber',
            'phone',
            'email',
            'gender',
            'dateOfBirth',
            'address',
            'city',
            'state',
            'pincode',
            'country',
            'stayType',
            'anyRelativeIn',
            'fatherName',
            'fatherEducation',
            'motherName',
            'motherEducation',
            'annualIncome',
            'religion',
            'category',
            'caste',
            'motherTongue',
            'parmanentAddress',
            'guardianName',
            'transport',
            'isActive',
            'action',
            'classDetails'
        ];
        setColumnVisibility(defaultVisibility);
        setColumnOrder(defaultOrder);
        saveColumnPreferences(defaultVisibility, defaultOrder);
    };

    // Handle column popover open
    const handleColumnPopoverOpen = (event) => {
        setAnchorEl(event.currentTarget);
    };

    // Handle column popover close
    const handleColumnPopoverClose = () => {
        setAnchorEl(null);
    };

    // Get visible columns in order
    const getVisibleColumns = () => {
        return columnOrder.filter(col => columnVisibility[col] !== false);
    };

    useEffect(() => {
        if (hasFetched.current) return;
        hasFetched.current = true;
        fetchStudents();
        loadColumnPreferences();
    }, []);

    const fetchStudents = async () => {
        setLoading(true);
        try {
            const url = authService.pathUrl('GET', '/students/school');
            const response = await authService.getAuth(url);
            setStudents(response);
            setFilteredStudents(response);
            setOpenForm(response.length === 0 ? true : false)
        } catch (err) {
            console.error('Error fetching students:', err);
            setError(err.message);
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <Box sx={{ width: "100%", mb: 3 }}>
                <LinearProgress />
            </Box>
        );
    }

    if (error) {
        return (
            <Container maxWidth="md">
                <Alert severity="error" sx={{ mt: 5 }}>
                    {error}
                </Alert>
            </Container>
        );
    }

    const handleOpen = (type, data = null) => {
        if (type === "update") {
            setSelectedStudent(data);
            setOpenForm(true);
        } else if (type === "add") {
            setSelectedStudent(null);
            setOpenForm(true);
        } else if (type === "upload") {
            setUpload(true)
            setSelectedStudent(data);
        } else if (type === 'marks') {
            setOpenMark(true);
            setMarksheet(data);
        } else if (type === "promote") {
            setClass(true);
            setClassRoom({ studentId: data.studentId });
            setEditingClassRoom(null);
        } else if (type === 'updateClass') {
            setClass(true);
            setEditingClassRoom(data);
        } else if (type === 'markentry') {
            setOpenEntry(true);
            setMarkEntry(data);
        }
    };

    function IframePDFViewer({ fileUrl }) {
        return (
            <iframe
                src={DOC_URL + fileUrl}
                width="100%"
                height={isMobile ? "400px" : "600px"}
                title="PDF Viewer"
            />
        );
    }

    const viewAllmarksheet = (marksheets, room) => {
        sessionStorage.setItem("hide", false);
        const data = marksheets.map(data => ({
            ...room,
            studentName: [room?.name, room?.father, room?.last].filter(Boolean).join(" "),
            photo: DOC_URL + room?.photo,
            ...data
        }));

        navigate('/certificate', {
            state: {
                data
            }
        })
    }

    const handleBulkMarksheet = () => {

        // const data = students.map(student => ({
        //   ...student,
        //   classRoom: student.classRoom.filter(
        //     room => room.academicYear === currentAcademicYear
        //   )
        // }));
        // console.log(data);

        const data = students.flatMap(student =>
            student.classRoom
                .filter(room => room.academicYear === currentAcademicYear)
                .flatMap(room =>
                    room.marksheets.map(marksheet => ({
                        name: student.firstName,
                        last: student.lastName,
                        father: student.fatherName,
                        mother: student.motherName,
                        birthday: student.dateOfBirth,
                        photo: DOC_URL + student.photo,
                        studentName: `${student.firstName} ${student.fatherName} ${student.lastName}`,
                        ...marksheet
                    }))
                )
        );

        navigate('/bulk-marksheet', {
            state: {
                data
            }
        })
    };

    const viewTransfer = (students) => {
        navigate('/transfer', {
            state: {
                students
            }
        })
    }

    const handleAdd = async (data) => {
        if (editingClassRoom) {
            const url = authService.pathUrl('PUT', '/classroom/promote/' + editingClassRoom.classId)
            await authService.putAuth(url, data);
            setEditingClassRoom(null);
        } else {
            const url = authService.pathUrl('POST', '/classroom/promote')
            await authService.postAuth(url, data);
        }
        setOpenEntry(false);
        setClass(false);
        fetchStudents();
    };

    const handleClose = () => {
        setOpenForm(false);
        setUpload(false);
        setOpenMark(false);
        setClass(false);
        setOpenEntry(false);
        setSelectedStudent(null);
    };

    const handleSubmit = async (studentData) => {
        setOpenForm(false);
        try {
            if (studentData.id) {
                const url = authService.pathUrl('PUT', `/students/${studentData.id}`);
                await authService.putAuth(url, studentData);
            } else {
                const url = authService.pathUrl('POST', '/students');
                await authService.postAuth(url, studentData);
            }
            handleClose();
            fetchStudents();
        } catch (error) {
            console.error("Error saving student:", error);
        }
    }

    const toggleRow = (id) => {
        setOpenRow((prev) => ({ ...prev, [id]: !prev[id] }));
    };

    const toggleCard = (id) => {
        setExpandedCards((prev) => ({ ...prev, [id]: !prev[id] }));
    };

    const handleCloseSnackbar = () => {
        setSnackbar((prev) => ({ ...prev, open: false }));
    };

    const showSnackbar = (message, severity = 'info') => {
        setSnackbar({ open: true, message, severity });
    };

    const handleRefreshAll = () => {
        fetchStudents();
        showSnackbar('Refreshing all data...', 'info');
    };

    const handleSearchChange = (e) => {
        setSearch({
            ...search,
            [e.target.name]: e.target.value,
        });
    };

    const handleInactive = async (stud) => {
        const url = authService.pathUrl('DELETE', `/students/${stud.id}`);
        await authService.deleteAuth(url);
        fetchStudents();
    }

    const handleDelete = async (sub) => {
        Swal.fire({
            icon: 'warning',
            title: 'Permanent Delete',
            text: "This student's class room will be permanently deleted all information and cannot be recovered.",
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'You are Sure, Yes',
            cancelButtonText: 'Cancel',
            customClass: {
                confirmButton: 'custom-confirm',
                cancelButton: 'custom-cancel',
            },
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const url = authService.pathUrl('DELETE', `/classroom/${sub.classId}`);
                    await authService.deleteAuth(url);
                    fetchStudents();
                } catch (error) {
                    console.error('Failed to delete student:', error);
                }
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                console.log('User declined to delete the student');
            }
        });
    }

    const handleStudentDelete = async (sub) => {
        Swal.fire({
            icon: 'warning',
            title: 'Permanent Delete',
            text: 'This student will be permanently deleted all information and cannot be recovered.',
            showConfirmButton: true,
            showCancelButton: true,
            confirmButtonText: 'You are Sure, Yes',
            cancelButtonText: 'Cancel',
            customClass: {
                confirmButton: 'custom-confirm',
                cancelButton: 'custom-cancel',
            },
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    const url = authService.pathUrl('DELETE', `/students/${sub.id}`);
                    await authService.deleteAuth(url);
                    fetchStudents();
                } catch (error) {
                    console.error('Failed to delete student:', error);
                }
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                console.log('User declined to delete the student');
            }
        });
    };

    const handleSearch = () => {
        const keyword = search.keyword.trim().toLowerCase();

        if (!keyword) {
            setFilteredStudents(students);
            return;
        }

        const filtered = students.filter((student) => {
            switch (search.searchBy) {
                case "fullName":
                    return `${student.firstName} ${student.lastName}`.toLowerCase().includes(keyword);
                case "academicYear":
                    return student.classRoom?.some((room) =>
                        room.academicYear?.toLowerCase().includes(keyword)
                    );
                case "aadhaarNumber":
                    return student.aadhaarNumber?.toLowerCase().includes(keyword);
                case "isActive":
                    return student.isActive?.toString().toLowerCase().includes(keyword);
                default:
                    return student[search.searchBy]?.toString().toLowerCase().includes(keyword);
            }
        });

        setFilteredStudents(filtered);
    };

    // Render mobile card view
    const renderMobileCard = (student) => {
        const isExpanded = expandedCards[student.id] || false;

        return (
            <Card
                key={student.id}
                sx={{
                    mb: 2,
                    borderLeft: `4px solid ${student.isActive ? '#4caf50' : '#e0e0e0'}`,
                    borderRadius: 2,
                    overflow: 'hidden'
                }}
            >
                <CardContent sx={{ p: 2 }}>
                    <Box display="flex" alignItems="center" gap={2}>
                        <Avatar src={DOC_URL + student.photo} sx={{ width: 50, height: 50 }} />
                        <Box flex={1}>
                            <Typography variant="subtitle1" fontWeight="bold">
                                {student.firstName} {student.lastName}
                            </Typography>
                            <Box display="flex" gap={1} flexWrap="wrap">
                                <Chip
                                    label={student.isActive ? 'Active' : 'Inactive'}
                                    color={student.isActive ? 'success' : 'default'}
                                    size="small"
                                />
                                {student.gender && (
                                    <Chip
                                        label={student.gender}
                                        size="small"
                                        icon={student.gender === 'MALE' ? <MaleIcon /> : <FemaleIcon />}
                                    />
                                )}
                            </Box>
                        </Box>
                        <IconButton onClick={() => toggleCard(student.id)} size="small">
                            {isExpanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                        </IconButton>
                    </Box>

                    {/* Basic Info always visible */}
                    <Box display="flex" flexWrap="wrap" gap={2} mt={1.5}>
                        {student.phone && (
                            <Box display="flex" alignItems="center" gap={0.5}>
                                <PhoneIcon fontSize="small" color="action" />
                                <Typography variant="body2">{student.phone}</Typography>
                            </Box>
                        )}
                        {student.classRoom?.length > 0 && (
                            <Box display="flex" alignItems="center" gap={0.5}>
                                <SchoolIcon fontSize="small" color="action" />
                                <Typography variant="body2">
                                    {student.classRoom[0]?.standard} - {student.classRoom[0]?.section}
                                </Typography>
                            </Box>
                        )}
                    </Box>
                </CardContent>

                <Collapse in={isExpanded}>
                    <Divider />
                    <CardContent sx={{ pt: 1, pb: 1 }}>
                        <Grid container spacing={1}>
                            <Grid item xs={6}>
                                <Typography variant="caption" color="textSecondary">Student Code</Typography>
                                <Typography variant="body2">{student.studentCode || 'N/A'}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="caption" color="textSecondary">Aadhaar</Typography>
                                <Typography variant="body2">{student.aadhaarNumber || 'N/A'}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="caption" color="textSecondary">DOB</Typography>
                                <Typography variant="body2">{student.dateOfBirth || 'N/A'}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="caption" color="textSecondary">Email</Typography>
                                <Typography variant="body2">{student.email || 'N/A'}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="caption" color="textSecondary">Father</Typography>
                                <Typography variant="body2">{student.fatherName || 'N/A'}</Typography>
                            </Grid>
                            <Grid item xs={6}>
                                <Typography variant="caption" color="textSecondary">Mother</Typography>
                                <Typography variant="body2">{student.motherName || 'N/A'}</Typography>
                            </Grid>
                            <Grid item xs={12}>
                                <Typography variant="caption" color="textSecondary">Address</Typography>
                                <Typography variant="body2">{student.address || student.parmanentAddress || 'N/A'}</Typography>
                            </Grid>
                        </Grid>
                    </CardContent>

                    <Divider />
                    <CardActions sx={{ flexWrap: 'wrap', gap: 0.5, p: 1.5 }}>
                        <IconButton onClick={() => handleOpen("update", student)} title="Update" size="small">
                            <Edit fontSize="small" />
                        </IconButton>
                        <IconButton onClick={() => handleOpen("upload", student)} title="Upload" size="small">
                            <CloudUploadIcon fontSize="small" />
                        </IconButton>
                        <IconButton onClick={() => handleStudentDelete(student)} title="Delete" size="small">
                            <Delete sx={{ color: 'red' }} fontSize="small" />
                        </IconButton>
                        {student?.documents && (
                            <IconButton onClick={() => { setShowPdf(student?.documents); setOpen(!open) }} size="small">
                                <PdfIcon fontSize="small" />
                            </IconButton>
                        )}
                        <IconButton onClick={() => viewTransfer(student)} title="Transfer" size="small">
                            <Description fontSize="small" />
                        </IconButton>
                    </CardActions>
                </Collapse>
            </Card>
        );
    };

    // Render column header
    const renderColumnHeader = (columnKey) => {
        switch (columnKey) {
            case 'expand':
                return <TableCell><strong>#</strong></TableCell>;
            case 'id':
                return <TableCell><strong>ID</strong></TableCell>;
            case 'studentCode':
                return <TableCell><strong>Student Code</strong></TableCell>;
            case 'image':
                return <TableCell><strong>Photo</strong></TableCell>;
            case 'firstName':
                return <TableCell><strong>First Name</strong></TableCell>;
            case 'lastName':
                return <TableCell><strong>Last Name</strong></TableCell>;
            case 'fullName':
                return <TableCell><strong>Full Name</strong></TableCell>;
            case 'aadhaarNumber':
                return <TableCell><strong>Aadhaar</strong></TableCell>;
            case 'phone':
                return <TableCell><strong>Phone</strong></TableCell>;
            case 'email':
                return <TableCell><strong>Email</strong></TableCell>;
            case 'gender':
                return <TableCell><strong>Gender</strong></TableCell>;
            case 'dateOfBirth':
                return <TableCell><strong>DOB</strong></TableCell>;
            case 'address':
                return <TableCell><strong>Address</strong></TableCell>;
            case 'city':
                return <TableCell><strong>City</strong></TableCell>;
            case 'state':
                return <TableCell><strong>State</strong></TableCell>;
            case 'pincode':
                return <TableCell><strong>Pincode</strong></TableCell>;
            case 'country':
                return <TableCell><strong>Country</strong></TableCell>;
            case 'stayType':
                return <TableCell><strong>Stay Type</strong></TableCell>;
            case 'anyRelativeIn':
                return <TableCell><strong>Relative In</strong></TableCell>;
            case 'fatherName':
                return <TableCell><strong>Father</strong></TableCell>;
            case 'fatherEducation':
                return <TableCell><strong>Father Edu.</strong></TableCell>;
            case 'motherName':
                return <TableCell><strong>Mother</strong></TableCell>;
            case 'motherEducation':
                return <TableCell><strong>Mother Edu.</strong></TableCell>;
            case 'annualIncome':
                return <TableCell><strong>Annual Income</strong></TableCell>;
            case 'religion':
                return <TableCell><strong>Religion</strong></TableCell>;
            case 'category':
                return <TableCell><strong>Category</strong></TableCell>;
            case 'caste':
                return <TableCell><strong>Caste</strong></TableCell>;
            case 'motherTongue':
                return <TableCell><strong>Mother Tongue</strong></TableCell>;
            case 'parmanentAddress':
                return <TableCell><strong>Permanent Address</strong></TableCell>;
            case 'guardianName':
                return <TableCell><strong>Guardian</strong></TableCell>;
            case 'transport':
                return <TableCell><strong>Transport</strong></TableCell>;
            case 'isActive':
                return <TableCell><strong>Status</strong></TableCell>;
            case 'action':
                return <TableCell><strong>Action</strong></TableCell>;
            case 'classDetails':
                return <TableCell><strong>Class Details</strong></TableCell>;
            default:
                return null;
        }
    };

    // Render column cell
    const renderColumnCell = (columnKey, student) => {
        switch (columnKey) {
            case 'expand':
                return (
                    <TableCell>
                        {student?.classRoom?.length > 0 && (
                            <IconButton size="small" onClick={() => toggleRow(student.id)}>
                                {openRow[student.id] ? <KeyboardArrowUp /> : <KeyboardArrowDown />}
                            </IconButton>
                        )}
                    </TableCell>
                );
            case 'id':
                return <TableCell>{student.id}</TableCell>;
            case 'studentCode':
                return <TableCell>{student.studentCode || 'N/A'}</TableCell>;
            case 'image':
                return (
                    <TableCell>
                        <Avatar src={DOC_URL + student.photo} sx={{ width: 40, height: 40 }} />
                    </TableCell>
                );
            case 'firstName':
                return <TableCell>{student.firstName || 'N/A'}</TableCell>;
            case 'lastName':
                return <TableCell>{student.lastName || 'N/A'}</TableCell>;
            case 'fullName':
                return <TableCell>{`${student.firstName || ''} ${student.lastName || ''}`.trim() || 'N/A'}</TableCell>;
            case 'aadhaarNumber':
                return <TableCell>{student.aadhaarNumber || 'N/A'}</TableCell>;
            case 'phone':
                return <TableCell>{student.phone || 'N/A'}</TableCell>;
            case 'email':
                return <TableCell>{student.email || 'N/A'}</TableCell>;
            case 'gender':
                return (
                    <TableCell>
                        <Chip
                            label={student.gender || 'N/A'}
                            icon={student.gender === 'MALE' ? <MaleIcon /> : student.gender === 'FEMALE' ? <FemaleIcon /> : null}
                            size="small"
                            color={student.gender === 'MALE' ? 'primary' : student.gender === 'FEMALE' ? 'secondary' : 'default'}
                        />
                    </TableCell>
                );
            case 'dateOfBirth':
                return <TableCell>{student.dateOfBirth || 'N/A'}</TableCell>;
            case 'address':
                return <TableCell sx={{ maxWidth: 150 }}>{student.address || 'N/A'}</TableCell>;
            case 'city':
                return <TableCell>{student.city || 'N/A'}</TableCell>;
            case 'state':
                return <TableCell>{student.state || 'N/A'}</TableCell>;
            case 'pincode':
                return <TableCell>{student.pincode || 'N/A'}</TableCell>;
            case 'country':
                return <TableCell>{student.country || 'N/A'}</TableCell>;
            case 'stayType':
                return <TableCell>{student.stayType || 'N/A'}</TableCell>;
            case 'anyRelativeIn':
                return <TableCell>{student.anyRelativeIn || 'N/A'}</TableCell>;
            case 'fatherName':
                return <TableCell>{student.fatherName || 'N/A'}</TableCell>;
            case 'fatherEducation':
                return <TableCell>{student.fatherEducation || 'N/A'}</TableCell>;
            case 'motherName':
                return <TableCell>{student.motherName || 'N/A'}</TableCell>;
            case 'motherEducation':
                return <TableCell>{student.motherEducation || 'N/A'}</TableCell>;
            case 'annualIncome':
                return (
                    <TableCell>
                        {student.annualIncome ? new Intl.NumberFormat('en-IN', {
                            style: 'currency',
                            currency: 'INR',
                        }).format(student.annualIncome) : 'N/A'}
                    </TableCell>
                );
            case 'religion':
                return <TableCell>{student.religion || 'N/A'}</TableCell>;
            case 'category':
                return <TableCell>{student.category || 'N/A'}</TableCell>;
            case 'caste':
                return <TableCell>{student.caste || 'N/A'}</TableCell>;
            case 'motherTongue':
                return <TableCell>{student.motherTongue || 'N/A'}</TableCell>;
            case 'parmanentAddress':
                return <TableCell sx={{ maxWidth: 150 }}>{student.parmanentAddress || 'N/A'}</TableCell>;
            case 'guardianName':
                return <TableCell>{student.guardianName || 'N/A'}</TableCell>;
            case 'transport':
                return <TableCell>{student.transport || 'N/A'}</TableCell>;
            case 'isActive':
                return (
                    <TableCell>
                        <Chip onClick={() => handleInactive(student)}
                            label={student.isActive ? "Active" : "Inactive"}
                            color={student.isActive ? "success" : "default"}
                            size="small"
                        />
                    </TableCell>
                );
            case 'action':
                return (
                    <TableCell>
                        <Stack direction="row" spacing={0.5} flexWrap="wrap">
                            <IconButton onClick={() => handleOpen("update", student)} title="Update" size="small">
                                <Edit sx={{ border: "2px solid", borderRadius: "10px" }} fontSize="small" />
                            </IconButton>
                            <IconButton onClick={() => handleOpen("upload", student)} title="Upload" size="small">
                                <CloudUploadIcon sx={{ border: "2px solid", borderRadius: "10px" }} fontSize="small" />
                            </IconButton>
                            {student?.documents && (
                                <IconButton onClick={() => { setShowPdf(student?.documents); setOpen(!open) }} size="small">
                                    <PdfIcon sx={{ border: "2px solid", borderRadius: "10px" }} fontSize="small" />
                                </IconButton>
                            )}
                            <IconButton onClick={() => viewTransfer(student)} title="Transfer" size="small">
                                <Description sx={{ border: "2px solid", borderRadius: "10px" }} fontSize="small" />
                            </IconButton>
                            <IconButton onClick={() => handleStudentDelete(student)} title="Delete" size="small">
                                <Delete sx={{ border: "2px solid", borderRadius: "10px", color: 'red' }} fontSize="small" />
                            </IconButton>
                        </Stack>
                    </TableCell>
                );
            case 'classDetails':
                return (
                    <TableCell>
                        {student?.classRoom?.length > 0 ? (
                            <Chip
                                label={`${student.classRoom.length} Class${student.classRoom.length > 1 ? 'es' : ''}`}
                                color="primary"
                                size="small"
                            />
                        ) : 'N/A'}
                    </TableCell>
                );
            default:
                return null;
        }
    };

    return (
        <Container maxWidth="xl" sx={{ p: isMobile ? 1 : 2 }}>
            {loading && (
                <Card sx={{ p: 3 }}>
                    <Typography variant="h6" gutterBottom>
                        Loading preview...
                    </Typography>
                    {[1, 2, 3, 4, 5].map((i) => (
                        <Skeleton
                            key={i}
                            variant="rectangular"
                            height={40}
                            sx={{ mb: 2, borderRadius: 1 }}
                        />
                    ))}
                </Card>
            )}

            <Paper elevation={3} sx={{ p: isMobile ? 1.5 : 3, borderRadius: 2, overflow: 'hidden' }}>
                <Box display="flex" justifyContent="space-between" alignItems="center" flexWrap="wrap" gap={1} mb={2}>
                    <Typography variant={isMobile ? "h6" : "h5"} fontWeight="bold" color="primary">
                        Student Details
                    </Typography>

                    <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap' }}>
                        <Tooltip title="Customize Columns">
                            <IconButton onClick={handleColumnPopoverOpen} color="warning" size={isMobile ? "small" : "medium"}>
                                <ViewColumnIcon sx={{ border: "2px solid", fontWeight: "bold", borderRadius: "10px" }} fontSize={isMobile ? "small" : "medium"} />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title="Refresh All Data">
                            <IconButton onClick={handleRefreshAll} color="warning" disabled={loading} size={isMobile ? "small" : "medium"}>
                                <RefreshIcon sx={{ border: "2px solid", fontWeight: "bold", borderRadius: "10px" }} fontSize={isMobile ? "small" : "medium"} />
                            </IconButton>
                        </Tooltip>
                        <IconButton
                            color="warning"
                            onClick={() => handleOpen("add")}
                            title="Add Student"
                            size={isMobile ? "small" : "medium"}
                        >
                            <Add sx={{ border: "2px solid", fontWeight: "bold", borderRadius: "10px" }} fontSize={isMobile ? "small" : "medium"} />
                        </IconButton>
                        <Tooltip title="Create Bulk Marksheet">
                            {user.is_permited.Bulk && (
                                <IconButton
                                    color="warning"
                                    onClick={handleBulkMarksheet}
                                    size={isMobile ? "small" : "medium"}
                                >
                                    <PictureAsPdfIcon fontSize={isMobile ? "small" : "medium"} />
                                </IconButton>
                            )}
                        </Tooltip>
                    </Box>
                </Box>

                {/* Column Customization Popover */}
                <Popover
                    open={openColumnPopover}
                    anchorEl={anchorEl}
                    onClose={handleColumnPopoverClose}
                    anchorOrigin={{
                        vertical: 'bottom',
                        horizontal: 'right',
                    }}
                    transformOrigin={{
                        vertical: 'top',
                        horizontal: 'right',
                    }}
                    PaperProps={{
                        sx: {
                            width: isMobile ? 280 : 350,
                            maxHeight: 500,
                            p: 2,
                        }
                    }}
                >
                    <Box>
                        <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                            <Typography variant="h6" fontSize="1rem" fontWeight="bold">
                                Customize Columns
                            </Typography>
                            <Button size="small" onClick={handleResetColumns}>
                                Reset
                            </Button>
                        </Box>

                        <Divider />

                        <List sx={{ pt: 1, overflow: 'auto', maxHeight: 350 }}>
                            {columnOrder.map((colKey) => {
                                const config = columnConfig[colKey];
                                if (!config) return null;
                                const isVisible = columnVisibility[colKey] !== false;

                                return (
                                    <ListItem
                                        key={colKey}
                                        dense
                                        sx={{
                                            borderRadius: 1,
                                            '&:hover': { backgroundColor: 'action.hover' },
                                        }}
                                    >
                                        <ListItemIcon sx={{ minWidth: 36 }}>
                                            {config.icon}
                                        </ListItemIcon>
                                        <ListItemText
                                            primary={config.label}
                                            primaryTypographyProps={{ variant: isMobile ? 'caption' : 'body2' }}
                                        />
                                        <Switch
                                            edge="end"
                                            checked={isVisible}
                                            onChange={() => handleColumnToggle(colKey)}
                                            color="primary"
                                            size="small"
                                        />
                                        {isVisible ? (
                                            <VisibilityIcon fontSize="small" color="primary" sx={{ ml: 1 }} />
                                        ) : (
                                            <VisibilityOffIcon fontSize="small" color="disabled" sx={{ ml: 1 }} />
                                        )}
                                    </ListItem>
                                );
                            })}
                        </List>

                        <Divider sx={{ my: 1 }} />

                        <Typography variant="caption" color="textSecondary" sx={{ display: 'block', textAlign: 'center' }}>
                            {getVisibleColumns().length} of {Object.keys(columnConfig).length} columns visible
                        </Typography>
                    </Box>
                </Popover>

                {/* Search Section */}
                <Box sx={{ mb: 3 }}>
                    <Grid container spacing={2} alignItems="center">
                        <Grid item xs={12} sm={6} md={3}>
                            <FormControl fullWidth size="small">
                                <InputLabel>Search By</InputLabel>
                                <Select
                                    name="searchBy"
                                    value={search.searchBy}
                                    label="Search By"
                                    onChange={handleSearchChange}
                                >
                                    <MenuItem value="aadhaarNumber">Aadhaar Number</MenuItem>
                                    <MenuItem value="fullName">Full Name</MenuItem>
                                    <MenuItem value="academicYear">Academic Year</MenuItem>
                                    <MenuItem value="isActive">Status</MenuItem>
                                    <MenuItem value="firstName">First Name</MenuItem>
                                    <MenuItem value="lastName">Last Name</MenuItem>
                                    <MenuItem value="phone">Phone</MenuItem>
                                    <MenuItem value="email">Email</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>

                        <Grid item xs={12} sm={6} md={3}>
                            <TextField
                                fullWidth
                                size="small"
                                label="Search"
                                name="keyword"
                                value={search.keyword}
                                onChange={handleSearchChange}
                                onKeyPress={(e) => e.key === 'Enter' && handleSearch()}
                            />
                        </Grid>

                        <Grid item xs={12} sm={6} md={3}>
                            <IconButton
                                color="warning"
                                onClick={handleSearch}
                                title="Search"
                            >
                                <Search sx={{ border: "2px solid", fontWeight: "bold", borderRadius: "10px" }} />
                            </IconButton>
                        </Grid>
                    </Grid>
                </Box>

                {filteredStudents?.length > 0 && !loading && (
                    <>
                        {isMobile ? (
                            // Mobile Card View
                            <Box>
                                {filteredStudents.map((student) => renderMobileCard(student))}
                            </Box>
                        ) : (
                            // Desktop Table View
                            <TableContainer component={Paper} elevation={0} sx={{ overflowX: 'auto' }}>
                                <Table size={isTablet ? "small" : "medium"} stickyHeader>
                                    <TableHead>
                                        <TableRow sx={{ backgroundColor: "#f5f5f5" }}>
                                            {getVisibleColumns().map((colKey) => renderColumnHeader(colKey))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {filteredStudents.map((student) => (
                                            <React.Fragment key={student.id}>
                                                <TableRow hover>
                                                    {getVisibleColumns().map((colKey) => renderColumnCell(colKey, student))}
                                                </TableRow>

                                                {/* Class Room Details Row */}
                                                {columnVisibility.classDetails && (
                                                    <TableRow>
                                                        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={getVisibleColumns().length}>
                                                            <Collapse in={openRow[student.id]} timeout="auto" unmountOnExit>
                                                                <Box sx={{ margin: 1 }}>
                                                                    <Box display="flex" justifyContent="space-between">
                                                                        <Typography variant="subtitle1" gutterBottom color="#3f2d01" fontWeight={'bold'}>
                                                                            <History sx={{ mr: 1, mb: -0.5 }} />
                                                                            Class Room History
                                                                        </Typography>
                                                                    </Box>
                                                                    <Divider sx={{ mb: 2 }} />
                                                                    <Table size="small">
                                                                        <TableHead>
                                                                            <TableRow sx={{ backgroundColor: '#fafafa' }}>
                                                                                <TableCell><strong>Class ID</strong></TableCell>
                                                                                <TableCell><strong>Standard</strong></TableCell>
                                                                                <TableCell><strong>Section</strong></TableCell>
                                                                                <TableCell><strong>Academic Year</strong></TableCell>
                                                                                <TableCell><strong>Admission Date</strong></TableCell>
                                                                                <TableCell><strong>Promotion Date</strong></TableCell>
                                                                                <TableCell><strong>Action</strong></TableCell>
                                                                                <TableCell><strong>Marksheet</strong></TableCell>
                                                                            </TableRow>
                                                                        </TableHead>
                                                                        <TableBody>
                                                                            {student?.classRoom?.map((sub) => (
                                                                                <TableRow key={sub.classId}>
                                                                                    <TableCell>{sub.classId}</TableCell>
                                                                                    <TableCell>{sub.standard}</TableCell>
                                                                                    <TableCell>{sub.section}</TableCell>
                                                                                    <TableCell>{sub.academicYear}</TableCell>
                                                                                    <TableCell>{sub.admissionDate || 'N/A'}</TableCell>
                                                                                    <TableCell>{sub.promotionDate || 'N/A'}</TableCell>
                                                                                    <TableCell>
                                                                                        <Stack direction="row" spacing={0.5}>
                                                                                            {sub.promotionDate == null && sub.academicYear === currentAcademicYear && (
                                                                                                <IconButton
                                                                                                    onClick={() => handleOpen("updateClass", sub)}
                                                                                                    title="Update Promotion"
                                                                                                    size="small"
                                                                                                >
                                                                                                    <Edit sx={{ border: "2px solid", borderRadius: "10px" }} fontSize="small" />
                                                                                                </IconButton>
                                                                                            )}
                                                                                            {new Date(sub?.promotionDate).getFullYear() !== new Date().getFullYear() && (
                                                                                                <IconButton
                                                                                                    onClick={() => handleOpen("promote", sub)}
                                                                                                    title="Promote next class"
                                                                                                    size="small"
                                                                                                >
                                                                                                    <AssignmentTurnedIn sx={{ border: "2px solid", fontWeight: "bold", borderRadius: "10px" }} fontSize="small" />
                                                                                                </IconButton>
                                                                                            )}
                                                                                            {new Date(sub?.promotionDate).getFullYear() === new Date().getFullYear() && (<>
                                                                                                <IconButton
                                                                                                    onClick={() => handleOpen("updateClass", sub)}
                                                                                                    title="Update Promotion"
                                                                                                    size="small"
                                                                                                >
                                                                                                    <Edit sx={{ border: "2px solid", borderRadius: "10px" }} fontSize="small" />
                                                                                                </IconButton>
                                                                                                <IconButton
                                                                                                    onClick={() => handleDelete(sub)}
                                                                                                    title="Delete Class"
                                                                                                    size="small"
                                                                                                >
                                                                                                    <Delete sx={{ border: "2px solid", borderRadius: "10px", color: 'red' }} fontSize="small" />
                                                                                                </IconButton>
                                                                                            </>
                                                                                            )}
                                                                                        </Stack>
                                                                                    </TableCell>
                                                                                    <TableCell>
                                                                                        <Stack direction="row" spacing={0.5}>
                                                                                            <IconButton
                                                                                                onClick={() => handleOpen("markentry", sub)}
                                                                                                title="Add Marks Entry"
                                                                                                size="small"
                                                                                                sx={{ border: "2px solid", fontWeight: "bold", borderRadius: "10px", padding: 0.5 }}
                                                                                            >
                                                                                                <AssignmentAdd fontSize="small" />
                                                                                            </IconButton>
                                                                                            {sub?.marksheets?.length > 0 && (
                                                                                                <IconButton
                                                                                                    onClick={() => { handleOpen("marks", sub?.marksheets); setRoom({ name: student.firstName, last: student.lastName, father: student.fatherName }) }}
                                                                                                    title="View Marksheet"
                                                                                                    size="small"
                                                                                                >
                                                                                                    <AssignmentIcon sx={{ border: "2px solid", borderRadius: "10px" }} fontSize="small" />
                                                                                                </IconButton>
                                                                                            )}
                                                                                            <IconButton
                                                                                                onClick={() => viewAllmarksheet(sub?.marksheets, { name: student.firstName, last: student.lastName, father: student.fatherName, mother: student.motherName, birthday: student.dateOfBirth, photo: student.photo })}
                                                                                                title="View All Marksheet"
                                                                                                size="small"
                                                                                            >
                                                                                                <SchoolIcon fontSize="small" sx={{ border: "2px solid", fontWeight: "bold", borderRadius: "10px" }} />
                                                                                            </IconButton>
                                                                                        </Stack>
                                                                                    </TableCell>
                                                                                </TableRow>
                                                                            ))}
                                                                        </TableBody>
                                                                    </Table>
                                                                </Box>
                                                            </Collapse>
                                                        </TableCell>
                                                    </TableRow>
                                                )}
                                            </React.Fragment>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        )}
                    </>
                )}
            </Paper>

            <Dialog open={open} onClose={() => setOpen(false)} maxWidth="lg" fullWidth>
                <IframePDFViewer fileUrl={showPdf} />
            </Dialog>

            {/* Modal with StudentForm */}
            <ModalView size={isMobile ? 'sm' : 'sm'}
                open={openForm}
                handleClose={handleClose}
                title={selectedStudent && selectedStudent.id ? (<><Edit sx={{ mr: 1, mb: -0.6 }} /> Update Student</>) : (<><Save sx={{ mr: 1, mb: -0.6 }} /> Register Student</>)}
                content={<StudentRegister
                    initialData={selectedStudent}
                    onSuccess={() =>
                        setTimeout(() => {
                            setOpenForm(false);
                            navigate("/fees-structure");
                        }, 5000)
                    }
                    onSubmit={handleSubmit}
                />}
            />

            <ModalView
                open={openMark}
                handleClose={handleClose}
                title="Marks View"
                content={<MarksView marksheets={marksheet} room={room} onSuccess={() => {
                    setOpenMark(false);
                }} />}
            />

            <ModalView size={isMobile ? 'lg' : 'lg'}
                open={openEntry}
                handleClose={handleClose}
                title="Add Marks"
                content={<MarksheetForm classRoomid={markEntry.classId} onSuccess={() => {
                    setOpenEntry(false);
                    fetchStudents();
                }} />}
            />

            <ModalView
                open={openClass}
                handleClose={handleClose}
                title={editingClassRoom ? "Update Class Room" : "Promote Student"}
                content={<ClassRoomForm initialData={editingClassRoom ? editingClassRoom : classRoom} onSubmit={handleAdd} />}
            />

            <ModalView
                size={isMobile ? "sm" : "sm"}
                open={upload}
                handleClose={handleClose}
                title="Upload Document/photo"
                content={
                    <FileUploadPage
                        Id={selectedStudent?.id}
                        Type="STD"
                        onSuccess={(fileData, type) => {
                            const updatedForm = {
                                ...selectedStudent,
                                photo: type === "photo"
                                    ? fileData?.path
                                    : selectedStudent?.photo,
                                documents: type === "pdf"
                                    ? fileData?.path
                                    : selectedStudent?.documents
                            };
                            handleSubmit(updatedForm);
                            setUpload(false);
                        }}
                    />
                }
            />

            <Snackbar
                open={snackbar.open}
                autoHideDuration={6000}
                onClose={handleCloseSnackbar}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
            >
                <Alert onClose={handleCloseSnackbar} severity={snackbar.severity} sx={{ width: '100%' }}>
                    {snackbar.message}
                </Alert>
            </Snackbar>
        </Container>
    );
};

export default StudentPage;